module.exports = __webpack_public_path__ + "img/sync.0141d1e0.svg";